import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/icons/notice-icon.png';
import _imports_1 from '@/assets/img/home/user_icon.png';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_2 = ["infinite-scroll-disabled"];
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "user-head"
}, null, -1);
const _hoisted_4 = {
  class: "flex-column"
};
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "time"
};
import { fetchNoticeList, readNotice } from "@/api/notice";
import { Socket } from "../utils/ws";
import { userStore } from "../stores/modules/user";
const __default__ = defineComponent({
  name: "myNotice"
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const loading = ref(false);
    const searchOption = reactive({
      pageNum: 1,
      pageSize: 5,
      status: "0"
    });
    const readList = ref([]);
    const disabled = ref(false);
    const noticeList = ref([]);
    const fetchData = () => {
      if (loading.value || disabled.value) return;
      loading.value = true;
      fetchNoticeList(searchOption).then(({
        data
      }) => {
        noticeList.value = noticeList.value.concat(data.list);
        searchOption.pageNum++;
        if (noticeList.value.length >= data.total) {
          disabled.value = true;
        }
        if (searchOption.status == "0") {
          readList.value = noticeList.value.map(x => x.id);
        }
        nextTick(() => {
          loading.value = false;
        });
      });
    };
    const userState = userStore();
    const noticeCount = ref(0);
    const ws = ref();
    watch(() => userState.isLogin, val => {
      if (val) {
        if (val) {
          ws.value = new Socket();
          ws.value.socket.onmessage = () => {
            noticeCount.value++;
          };
        }
        updateUnreadCount();
      }
    }, {
      immediate: true
    });
    watch(() => searchOption.status, val => {
      noticeList.value = [];
      searchOption.pageNum = 1;
      disabled.value = false;
      fetchNoticeList(searchOption).then(({
        data
      }) => {
        noticeList.value = noticeList.value.concat(data.list);
        searchOption.pageNum++;
        if (noticeList.value.length >= data.total) {
          disabled.value = true;
        }
      });
    });
    function updateUnreadCount() {
      fetchNoticeList({
        pageNum: 1,
        pageSize: 1,
        status: "0"
      }).then(({
        data
      }) => {
        noticeCount.value = data.total;
      });
    }
    const handleHide = async () => {
      searchOption.pageNum = 1;
      if (readList.value.length) await readNotice(readList.value);
      if (searchOption.status == "0") {
        noticeList.value = [];
        updateUnreadCount();
      }
    };
    const handleShow = () => {
      if (!noticeList.value.length) fetchData();
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_popover = _resolveComponent("el-popover");
      const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_popover, {
        width: 300,
        "popper-style": "",
        trigger: "click",
        "popper-class": "notice-popover",
        "hide-after": 0,
        persistent: false,
        onShow: handleShow,
        onHide: handleHide
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_badge, {
          value: _unref(noticeCount),
          class: "notice-badge",
          hidden: !_unref(noticeCount)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "notice-icon"
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          })]),
          _: 1
        }, 8, ["value", "hidden"])]),
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: _unref(searchOption).status,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchOption).status = $event),
          class: "notice-tabs notice-tabs_notToView"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
            label: '未读消息',
            name: '0'
          }, {
            label: '全部消息',
            name: '2'
          }], item => {
            return _withDirectives(_createVNode(_component_el_tab_pane, {
              key: item.name,
              label: item.label,
              name: item.name
            }, {
              default: _withCtx(() => [_unref(noticeList).length ? _withDirectives((_openBlock(), _createElementBlock("ul", {
                key: 0,
                class: "infinite-list flex-column no-scrollbar",
                style: {
                  "overflow": "auto"
                },
                "infinite-scroll-disabled": _unref(disabled),
                "infinite-scroll-immediate": false,
                "infinite-scroll-delay": 500
              }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noticeList), i => {
                return _openBlock(), _createElementBlock("li", {
                  key: i.id,
                  class: "infinite-list-item"
                }, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString(i.sendUserName || i.sendUserMobile || "未命名"), 1), _createElementVNode("p", {
                  class: "message",
                  innerHTML: i.message
                }, null, 8, _hoisted_6), _createElementVNode("p", _hoisted_7, _toDisplayString(i.updatedTime), 1)])]);
              }), 128))], 8, _hoisted_2)), [[_directive_infinite_scroll, fetchData]]) : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: "暂无数据"
              }))]),
              _: 2
            }, 1032, ["label", "name"]), [[_directive_loading, _unref(loading)]]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
});